/**
 * Where "Open in PeopleiKnow" should land after a logged-out visitor signs in.
 * Only a same-app contact id is stored. Nothing here is an open redirect.
 */

const KEY = 'pending_open_contact';
const ID_RE = /^[A-Za-z0-9_-]{1,80}$/;
const PATH_RE = /^\/open\/contact\/([A-Za-z0-9_-]{1,80})$/;

function store() {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function stashPendingContact(pathname) {
  const s = store();
  if (!s) return;
  const match = PATH_RE.exec(String(pathname || ''));
  if (!match) return;
  s.setItem(KEY, match[1]);
}

export function peekPendingContactPath() {
  const s = store();
  if (!s) return null;
  const id = s.getItem(KEY) || '';
  if (!ID_RE.test(id)) return null;
  return `/contacts/${id}`;
}

export function consumePendingContactPath() {
  const path = peekPendingContactPath();
  if (!path) return null;
  const s = store();
  if (s) s.removeItem(KEY);
  return path;
}

export function clearPendingContactIfMatches(pathname) {
  const pending = peekPendingContactPath();
  if (!pending) return;
  const here = String(pathname || '');
  const id = pending.slice('/contacts/'.length);
  if (here === pending || here === `/open/contact/${id}`) {
    const s = store();
    if (s) s.removeItem(KEY);
  }
}
